import { default as NextLink, LinkProps } from "next/link";
import { forwardRef, PropsWithChildren } from "react";

const Link = forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<LinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement>>
>((props, ref) => {
  return <NextLink {...props} ref={ref} prefetch={props.prefetch ?? false} />;
});

Link.displayName = "Link";

export default Link;
